;(function () {
  var scriptURL =
    'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js'
  if (window.ShopifyBuy) {
    if (window.ShopifyBuy.UI) {
      ShopifyBuyInit()
    } else {
      loadScript()
    }
  } else {
    loadScript()
  }
  function loadScript() {
    var script = document.createElement('script')
    script.async = true
    script.src = scriptURL
    ;(
      document.getElementsByTagName('head')[0] ||
      document.getElementsByTagName('body')[0]
    ).appendChild(script)
    script.onload = ShopifyBuyInit
  }
  function loadShopifyElement(ui, element) {
    ui.createComponent('collection', {
      id: element.dataset.shopifyId,
      node: element,
      moneyFormat: '%24%7B%7Bamount%7D%7D',
      options: {
        product: {
          styles: {
            product: {
              '@media (min-width: 601px)': {
                'max-width': 'calc(25% - 20px)',
                'margin-left': '20px',
                'margin-bottom': '50px',
                width: 'calc(25% - 20px)'
              },
              img: {
                height: 'calc(100% - 15px)',
                position: 'absolute',
                left: '0',
                right: '0',
                top: '0'
              },
              imgWrapper: {
                'padding-top': 'calc(75% + 15px)',
                position: 'relative',
                height: '0'
              }
            }
          },
          text: {
            button: 'Add to cart'
          }
        },
        productSet: {
          styles: {
            products: {
              '@media (min-width: 601px)': {
                'margin-left': '-20px'
              }
            }
          }
        },
        modalProduct: {
          contents: {
            img: false,
            imgWithCarousel: true,
            button: false,
            buttonWithQuantity: true
          },
          styles: {
            product: {
              '@media (min-width: 601px)': {
                'max-width': '100%',
                'margin-left': '0px',
                'margin-bottom': '0px'
              }
            }
          },
          text: {
            button: 'Add to cart'
          }
        },
        option: {},
        cart: {
          text: {
            total: 'Subtotal',
            button: 'Checkout'
          }
        },
        toggle: {}
      }
    })
  }
  function ShopifyBuyInit() {
    var client = ShopifyBuy.buildClient({
      domain: 'ibmq1f-bc.myshopify.com',
      storefrontAccessToken: '4b97778c564c2b739aa6555506d05bda'
    })
    ShopifyBuy.UI.onReady(client).then(function (ui) {
      document.querySelectorAll('.shopify-element').forEach((element) => {
        loadShopifyElement(ui, element)
      })
    })
  }
})()
